let mountedHostCount = 0;

export const registerRegistrationFlowHost = (): (() => void) => {
    let isRegistered = true;
    mountedHostCount += 1;

    return () => {
        if (isRegistered) {
            isRegistered = false;
            mountedHostCount -= 1;
        }
    };
};

export const isRegistrationFlowHostMounted = (): boolean => mountedHostCount > 0;
let mountedHostCount = 0;

export const registerRegistrationFlowHost = (): (() => void) => {
    let isRegistered = true;
    mountedHostCount += 1;

    return () => {
        if (isRegistered) {
            isRegistered = false;
            mountedHostCount -= 1;
        }
    };
};

export const isRegistrationFlowHostMounted = (): boolean => mountedHostCount > 0;
